"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/components/Modals/AddMembers/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _useOrgAccount = require('shared/hooks/useOrgAccount');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _createNew = require('shared/hooks/createNew');
var _chatParticipantQuotas = require('shared/constants/chatParticipantQuotas');
var _array = require('shared/services/array');
var _entity = require('shared/services/entity');
var _noticeBar = require('web/services/context/noticeBar');

var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal');
var _AccountRoleToggles = require('web/components/Settings/AccountRoleToggles'); var _AccountRoleToggles2 = _interopRequireDefault(_AccountRoleToggles);
var _ParticipantsPicker = require('web/components/ParticipantsPicker'); var _ParticipantsPicker2 = _interopRequireDefault(_ParticipantsPicker);
var _OrgLimitNotice = require('web/components/Upgrade/OrgLimitNotice'); var _OrgLimitNotice2 = _interopRequireDefault(_OrgLimitNotice);












const NO_ROLES = []

const AddMembersForm = ({
  onClose,
  orgKey,
  onSubmit,
  accountRoles = NO_ROLES,
}) => {
  const [accountRole, setAccountRole] = _react.useState(null)
  const {
    selectedEntitiesList,
    onSelectEntity,
    onRemoveEntity,
  } = _createNew.useSelectedEntities.call(void 0, )

  const { showWarningBar, showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isSubmitting, setIsSubmitting] = _react.useState.call(void 0, false)
  const handleSubmit = _react.useCallback.call(void 0, 
    () => {
      setIsSubmitting(true)

      const userKeys = selectedEntitiesList
        .map(e => _entity.isEntityUser.call(void 0, e) && e.wrappedEntity.UserKey)
        .filter(_array.truthy)

      // The role is granted once they're members; a failed grant leaves
      // them added.
      const grantRole = (role) => Promise
        .all(userKeys.map(UserKey => _actions2.default.grantAccountRole({ OrgKey: orgKey, UserKey, Role: role })))
        .then(
          () => showSuccessBar(`Users have been invited and made ${_useOrgAccount.ACCOUNT_ROLE_LABELS[role]}`),
          () => showWarningBar(`Users have been invited, but couldn't be made ${_useOrgAccount.ACCOUNT_ROLE_LABELS[role]}`),
        )

      return onSubmit(userKeys)
        .then(onClose)
        .then(() => accountRole ? grantRole(accountRole) : showSuccessBar('Users have been invited'))
        .catch(() => {
          showWarningBar('Failed to invite users')
          setIsSubmitting(false)
        })
    },
    [onSubmit, onClose, showWarningBar, showSuccessBar, selectedEntitiesList, accountRole, orgKey],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_OrgLimitNotice2.default, {
        orgKey: orgKey,
        addedUsersCount: selectedEntitiesList.length, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
      )
      , _react2.default.createElement(_ParticipantsPicker2.default, {
        orgKeyContext: orgKey,
        selectedEntitiesList: selectedEntitiesList,
        onSelectEntity: onSelectEntity,
        onRemoveEntity: onRemoveEntity,
        canInviteCollaborators: false,
        participantQuotas: _chatParticipantQuotas.USERS_ONLY_CHAT_QUOTA,
        className: "participants-picker--field",
        inputClassName: "participants-picker--field--input", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
      )
      ,  accountRoles.length > 0 && (
        _react2.default.createElement(_Form.InputSectionWrapper, { title: "Account role" , shouldCaptureFocus: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          , _react2.default.createElement(_AccountRoleToggles2.default, { roles: accountRoles, value: accountRole, onChange: setAccountRole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} )
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Add",
        onPrimaryBtnClick: handleSubmit,
        isPrimaryLoading: isSubmitting,
        isPrimaryEnabled: selectedEntitiesList.length > 0 && !isSubmitting,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
      )
    )
  )
}

exports. default = AddMembersForm
